// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"698":"2e6d2d2e","823":"670e62f8"}[chunkId] + ".chunk.js";
};